import React from 'react';
import PropTypes from 'prop-types';
import {colors} from './../../assets/theme';
import { runInThisContext } from 'vm';
class Divider extends React.Component {   

    constructor(props){
        super(props);
    }
    componentWillMount(){ }
    
    componentDidMount(){ }

    render(){
        return (
            <div className="Divider">
                <style jsx>{`
                    .Divider hr {
                        border:none;
                        border-bottom:1px solid ${colors.hiGrey};
                        margin-top : ${this.props.marginTop || 10 }px;
                        margin-bottom : ${this.props.marginBottom || 10 }px;
                    }
                `}</style>
                <hr/>
            </div>
        )
    }
}

Divider.propTypes = {
    marginTop : PropTypes.number,
    marginBottom : PropTypes.number   
}

export default Divider;


// WEBPACK FOOTER //
// ./src/components/common/Divider.js